import { RULES_LINKS, RULES_LINKS_NOFIRM } from "~/review/const";
import { CONFIG } from "~/config";
import { _ } from "~/i18n";

export function createReviewLicence(isFirm: boolean, clickCb: (type: "agr" | "rules") => void): HTMLElement {
	const lang = CONFIG.defaultLang;
	const rulesSource = isFirm ? RULES_LINKS : RULES_LINKS_NOFIRM;
	const rulesLink = Object.keys(rulesSource).indexOf(lang) > -1 ? rulesSource[lang] : rulesSource.en;
	const termsLink = `https://licence.mapy.${CONFIG.TLD}/?doc=mapy_lu&lang=${lang}`;
	const agreement = Mapy.Util.node("p", {
		className: "ui-reviewlicence",
		innerHTML: _("detail.content.review2.starsLicence", {
			linkAgrStart: `<a href="${termsLink}" target="_blank">`,
			linkAgrEnd: "</a>",
			linkRulStart: `<a href="${rulesLink}" target="_blank">`,
			linkRulEnd: "</a>",
		}),
	});

	Array.from(agreement.querySelectorAll("a")).forEach((item: HTMLAnchorElement, index: number) => {
		item.setAttribute("data-log-ignore", "true");
		item.addEventListener("pointerdown", () => {
			clickCb(index === 0 ? "agr" : "rules");
		});
	});

	return agreement;
}
